import { Box, Button, IconButton, TextField, Tooltip } from "@mui/material";
import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import DeleteIcon from "@mui/icons-material/Delete";
import { createLocationAdvice } from "../actions/location";
import { useDispatch, useSelector } from "react-redux";
import { deleteAdviceLocation } from "../actions/location";
import TableRow from "@mui/material/TableRow";
import { Helmet } from "react-helmet-async";
import secureLocalStorage from "react-secure-storage";
import { message, Popconfirm } from "antd";
const columns = [
  { id: "location", label: "Location", minWidth: 200 },
  { id: "code", label: "Code", minWidth: 200 },
];

export default function Location() {
  const user = JSON.parse(secureLocalStorage.getItem("profile"));
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const rows = useSelector((state) => state.location);
  const [postData, setPostData] = React.useState({
    location: "",
    code: "",
  });
  const dispatch = useDispatch();
  function sendData() {
    if (postData.location && postData.code) {
      dispatch(createLocationAdvice(postData));
      setPostData({
        location: "",
        code: "",
      });
    } else {
      alert("Please fill in all required fields");
    }
  }
  let notManipulate;

  if (user.results.e_advice === "Read Only") {
    notManipulate = true;
  } else {
    notManipulate = false;
  }
  const confirm = (id) => {
    dispatch(deleteAdviceLocation(id));
  };
  const cancel = () => {
    message.info("Nothing was submitted");
  };
  return (
    <div>
      <Helmet title='Locations | Advice' />
      <Box display={"flex"} flexDirection={"row"} marginBottom={5}>
        <TextField
          value={postData.location}
          onChange={(e) =>
            setPostData({ ...postData, location: e.target.value.toLowerCase() })
          }
          style={{ marginLeft: "20px" }}
          size='small'
          label='location'
          required
        />
        <TextField
          value={postData.code}
          onChange={(e) =>
            setPostData({ ...postData, code: e.target.value.toLowerCase() })
          }
          style={{ marginLeft: "20px" }}
          size='small'
          label='location code'
          required
        />
        <Button
          disabled={notManipulate}
          onClick={sendData}
          style={{ marginLeft: "10px" }}
          variant='contained'>
          Add
        </Button>
      </Box>
      <Paper>
        <TableContainer sx={{ maxHeight: 640 }}>
          <Table stickyHeader aria-label='sticky table' size='small'>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}>
                    {column.label}
                  </TableCell>
                ))}
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  return (
                    <TableRow hover role='checkbox' tabIndex={-1} key={row._id}>
                      <TableCell>{row.location}</TableCell>
                      <TableCell>{row.code}</TableCell>

                      <TableCell>
                        <Popconfirm
                          title='Delete location'
                          description='Proceed deleting location?'
                          okText='Yes'
                          onConfirm={() => confirm(row._id)}
                          onCancel={cancel}
                          cancelText='No'>
                          <Tooltip title='delete'>
                            <IconButton>
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </Popconfirm>
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
}
